import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';

interface ErrorMessageProps {
    isError: boolean;
}

export const ErrorMessage = styled('div', { label: 'ErrorMessage' }) <ErrorMessageProps>`

    background: ${mainColors.status.error};
    color: white;
    display: ${({ isError }): string => isError ? 'block' : 'none'};
    font-weight: 600;
    padding: 5px 0 5px;
    text-align: center;
`;
interface PayButtonTextProps {
    isDisabled: boolean;
}
export const PayButton = styled('button', { label: 'PayButton' })`
    background: transparent;
    border-radius: 3px;
    border: 1px solid #ccc;
    color: #888;
    cursor: pointer;
    display: inline-block;
    font-size: 0.95em;
    font-weight: bold;
    margin: 0 5px 0 0;
    line-height: 1em;
    outline: none;
    padding: 0.6em 1em;
    text-decoration: none;
    text-transform: capitalize;
    vertical-align: middle;
    width: 100%;
`;

export const PayButtonText = styled('span', { label: 'PayButtonText' }) <PayButtonTextProps>`
    opacity: ${({ isDisabled }): string => isDisabled ? '0.3' : '1'};
`;

interface SuccessMessageProps {
    isSuccess: boolean;
}

export const SuccessMessage = styled('div', { label: 'SuccessMessage' })<SuccessMessageProps>`
    background-color: ${mainColors.status.success};
    border-radius: 2px;
    color: ${mainColors.default.light};
    display: ${({ isSuccess }): string => isSuccess ? 'block' : 'none'};
    font-size: 15px;
    padding: 11px 8px 13px 8px;
    text-align: center;
`;
